import { SvgNames } from "types/business/SvgNames";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = SvgNames;

export const useDefaultObservableSvgNames = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectSvgNames extends BehaviorSubject<CurrentType> {}
